var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"breadcrumb padding-site"},[_c('h1',[_vm._t("title")],2),_c('p',[_vm._t("default"),_vm._v(" / "),_vm._t("parent"),_vm._v(" "),_c('span',[_vm._t("title")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }